import { create } from "zustand";
import apiClient from "../helpers/api-client";
import { INVITE_STATUS_SENT } from "../helpers/constants";
import moment from "moment";
import {
  API_ENDPOINT_ACCEPT_INVITE,
  API_ENDPOINT_DELETE_INVITE,
  API_ENDPOINT_SEARCH_NETWORK,
  API_ENDPOINT_SEND_INVITE,
} from "src/helpers/endpoint-urls";

const networkStore = create((set: any, get: any) => ({
  searchNetwork: async (search: string) => {
    return await apiClient.get(API_ENDPOINT_SEARCH_NETWORK, {
      params: new URLSearchParams({ search }),
    });
  },

  sendInvite: async ({
    to,
    sentByName,
    sentToName,
    sendToThisEmail,
  }: {
    to: string;
    sentByName: string;
    sentToName: string;
    sendToThisEmail: string;
  }) => {
    return await apiClient
      .post(API_ENDPOINT_SEND_INVITE, {
        to,
        status: INVITE_STATUS_SENT,
        date: moment().format("yyyy-MM-DD hh:mm:ss tt"),
        sentByName,
        sentToName,
        sendToThisEmail,
      })
      .then((res: any) => {
        return res?.data?.success || false;
      })
      .catch((e: any) => {
        return e;
      });
  },

  deleteInvite: async ({ inviteIds }: { inviteIds: Array<any> }) => {
    return await apiClient.delete(
      `${API_ENDPOINT_DELETE_INVITE}/${JSON.stringify(inviteIds)}`,
      {},
    );
  },

  acceptInvite: async ({ inviteIds }: { inviteIds: Array<any> }) => {
    return await apiClient.put(`${API_ENDPOINT_ACCEPT_INVITE}`, {
      inviteIds,
      status: "ACCEPTED",
    });
  },
}));

export default networkStore;
